import { useState } from "react";
import styles from "./Newsletter.module.scss";
import { useTranslation } from "react-i18next";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("translation");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);

    setTimeout(() => {
      console.log("Newsletter subscription:", email);
      setEmail("");
      setLoading(false);
    }, 1000);
  };

  return (
    <section className={styles.newsletter_section}>
      <div className="container">
        <div className={styles.newsletter_content}>
          <div className={styles.form_wrapper}>
            <div className={styles.icon}>✉️</div>
            <h2 className={styles.title}>{t("newsletter_title")}</h2>
            <p className={styles.description}>{t("newsletter_desc")}</p>
            <form onSubmit={handleSubmit} className={styles.form}>
              <input
                type="email"
                placeholder={t("newsletter_placeholder") as string}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={styles.input}
                required
              />
              <button
                type="submit"
                disabled={loading}
                className={styles.submit_btn}
              >
                {loading ? t("loading") : t("subscribe")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
